import { type FC } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { appRoutes } from './appRoutes';

// Una sola instancia por carga de la app: useBlocker (guard de cambios sin guardar) vive en el router.
const router = createBrowserRouter(appRoutes);

const App: FC = () => <RouterProvider router={router} />;

export default App;
